/* eslint-disable quotes */

import * as React from "react";
import PropTypes from "prop-types";

export default class ToolTip extends React.PureComponent {

  static propTypes = {
    "arrowPosition": PropTypes.string,
    "classes": PropTypes.string,
    "color": PropTypes.string,
    "content": PropTypes.string.isRequired,
    "handleTooltipClose": PropTypes.func.isRequired,
    "showToolTip": PropTypes.bool
  };

  static defaultProps = {
    "arrowPosition": "center",
    "classes": "",
    "color": "pink",
    "showToolTip": true
  }

  displayColorClass = () => {
    const {color} = this.props;

    return color === "pink" ? "tool-tip-pink" : "tool-tip-grey";
  }

  render () {
    const {arrowPosition, classes, content, color, showToolTip, handleTooltipClose} = this.props;
    return (
      <React.Fragment>
        {showToolTip &&
          <div className={`tool-tip ${arrowPosition}-arrow ${classes} ${this.displayColorClass()}`}>
            <div
              className="tool-tip-exit-button"
              onClick={handleTooltipClose}
            >
              x
            </div>
            <div className={`tool-tip-text ${color === "pink" ? "tool-tip-text-pink" : "tool-tip-text-grey"}`}>
              {content}
            </div>
          </div>
        }
      </React.Fragment>
    );
  }
}
